import { paths } from '@luxuryescapes/contract-search'
import {
  validateExtractedCheckInOrCheckOutDate,
  deserialiseOccupancy,
  convertDateRangesToMonthString,
  mapFlexibleNightsToDurationRange,
} from 'lib/search/searchUtils'
import { ExtractDatesResponse } from 'api/naturalLanguageSearch'

type ExtractOccupancyResponse =
  paths['/api/search/hotel/v1/extract/occupancy']['post']['responses']['200']['content']['application/json']

export function mapExtractDatesResponse(response: ExtractDatesResponse): App.ExtractDatesResult {
  const flexibleNights = mapFlexibleNightsToDurationRange(response.flexibleNights)
  const flexibleMonths = convertDateRangesToMonthString(response.flexibleMonths)
  return {
    checkinDate: validateExtractedCheckInOrCheckOutDate(response.checkIn),
    checkoutDate: validateExtractedCheckInOrCheckOutDate(response.checkOut),
    flexibleNights: flexibleNights && flexibleMonths ? flexibleNights : undefined,
    flexibleMonths: flexibleNights && flexibleMonths ? flexibleMonths : undefined,
  }
}

export function mapExtractOccupancyResponse(response: ExtractOccupancyResponse): App.ExtractOccupancyResult {
  if (!response.occupancy?.length) {
    return { occupancies: undefined }
  }

  return {
    occupancies: deserialiseOccupancy(response.occupancy)
  }
}
